import React, { useState } from 'react';
import { FaPlus, FaSave } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../../../../../../header/header';
import Navvbar from '../../../../../../header/Navvbar';
import Footer from '../../../../../../footer';
import Sidebar from '../../../../../../Sidebar';
import './AddnextCase.css';

const AddnextCase = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    availableStage: 'Case closed or invoiced',
    descriptionRequired: false,
    preselectedProcedure: 'None',
    noteRequired: false,
    copyPracticeNote: false,
    copyPracticeFiles: false,
    remakeNote: false,
    descriptions: []
  });

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ name: '', amount: '' });

  const userLabId = localStorage.getItem('userLabId') || 'defaultLabId';

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setModalData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddDescription = () => {
    if (modalData.name.trim() && modalData.amount.trim()) {
      setFormData((prev) => ({
        ...prev,
        descriptions: [
          ...prev.descriptions,
          { description: modalData.name.trim(), amount: modalData.amount.trim() }
        ]
      }));
      setModalData({ name: '', amount: '' });
      setShowModal(false);
    } else {
      alert('Please enter description name and amount.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const nextCaseData = {
        userLabId,
        reason: formData.name,
        description:
          formData.descriptions.length > 0
            ? formData.descriptions.map((d) => `${d.description} (${d.amount})`).join(', ')
            : '',
        availableStage: formData.availableStage,
        descriptionRequired: formData.descriptionRequired,
        preselectedProcedure: formData.preselectedProcedure,
        noteRequired: formData.noteRequired,
        copyPracticeNote: formData.copyPracticeNote,
        copyPracticeFiles: formData.copyPracticeFiles,
        remakeNote: formData.remakeNote
      };

      const response = await axios.post('https://hms.backend.hiragroupcloud.com/api/remake-types', nextCaseData);

      if (response.data.success) {
        alert('Next case type added successfully!');
        navigate('/CaseSetting');
      }
    } catch (error) {
      console.error('Error saving next case type:', error);
      alert(error.response?.data?.message || 'Failed to save next case type. Please try again.');
    }
  };

  return (
    <>
      <div style={{ marginBottom: '15px' }}>
        <Header />
        <Navvbar />
      </div>

      <div className="anc-wrapper">
        <div className="anc-container">
          
          {/* ===== SIDEBAR ===== */}
          <div className="anc-sidebar">
            <Sidebar />
          </div>

          {/* ===== MAIN CONTENT ===== */}
          <div className="anc-main">
            <h3 className="anc-page-title">Add Next-case Type</h3>

            <form onSubmit={handleSubmit}>
              {/* Details Section */}
              <div>
                <h4 className="anc-section-title">Details</h4>
                <div className="anc-box">
                  <div className="anc-row">
                    <label className="anc-label">
                      Name <span className="anc-required">*</span>
                    </label>
                    <div className="anc-field">
                      <input type="text" name="name" value={formData.name} onChange={handleChange} required className="anc-input" />
                    </div>
                  </div>

                  <div className="anc-row">
                    <label className="anc-label">Available when the original case is in stage</label>
                    <div className="anc-field">
                      <span className="anc-text">Case closed or invoiced</span>
                    </div>
                  </div>

                  <div className="anc-row">
                    <label className="anc-label">Description selection required for Next case</label>
                    <div className="anc-field">
                      <input type="checkbox" name="descriptionRequired" checked={formData.descriptionRequired} onChange={handleChange} className="anc-checkbox" />
                    </div>
                  </div>

                  <div className="anc-row">
                    <label className="anc-label">Preselect Procedure on Next case</label>
                    <div className="anc-field">
                      <select name="preselectedProcedure" value={formData.preselectedProcedure} onChange={handleChange} className="anc-select">
                        <option value="None">None</option>
                        <option value="Procedure 1">Procedure 1</option>
                        <option value="Procedure 2">Procedure 2</option>
                        <option value="Procedure 3">Procedure 3</option>
                      </select>
                    </div>
                  </div>

                  <div className="anc-row">
                    <label className="anc-label">Note required on Next case</label>
                    <div className="anc-field">
                      <input type="checkbox" name="noteRequired" checked={formData.noteRequired} onChange={handleChange} className="anc-checkbox" />
                    </div>
                  </div>

                  <div className="anc-row">
                    <label className="anc-label">Copy practice note to next-case</label>
                    <div className="anc-field">
                      <input type="checkbox" name="copyPracticeNote" checked={formData.copyPracticeNote} onChange={handleChange} className="anc-checkbox" />
                    </div>
                  </div>

                  <div className="anc-row">
                    <label className="anc-label">Copy practice files to next-case</label>
                    <div className="anc-field">
                      <input type="checkbox" name="copyPracticeFiles" checked={formData.copyPracticeFiles} onChange={handleChange} className="anc-checkbox" />
                    </div>
                  </div>

                  <div className="anc-row">
                    <label className="anc-label">Remake note in previous case</label>
                    <div className="anc-field anc-field-inline">
                      <input type="checkbox" name="remakeNote" checked={formData.remakeNote} onChange={handleChange} className="anc-checkbox" />
                      <span className="anc-text">Create a case note about the remake in the previous case</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Descriptions Section */}
              <div>
                <h4 className="anc-section-title">Descriptions</h4>
                <div className="anc-box anc-desc-box">
                  <div className="anc-add-row">
                    <button type="button" onClick={() => setShowModal(true)} className="anc-btn-primary">
                      <FaPlus size={12} /> Add
                    </button>
                  </div>

                  <div className="anc-table-wrapper">
                    <table className="anc-table">
                      <thead>
                        <tr>
                          <th className="anc-th anc-th-desc">Description</th>
                          <th className="anc-th anc-th-amount">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.descriptions.length === 0 ? (
                          <tr>
                            <td colSpan="2" className="anc-empty">No data available in table</td>
                          </tr>
                        ) : (
                          formData.descriptions.map((item, index) => (
                            <tr key={index} className="anc-tr">
                              <td className="anc-td">{item.description}</td>
                              <td className="anc-td anc-td-amount">{item.amount}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Save Button */}
              <div className="anc-save-row">
                <button type="submit" className="anc-btn-primary anc-btn-save">
                  <FaSave size={13} /> Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="anc-modal-overlay">
          <div className="anc-modal">
            <div className="anc-modal-header">
              <h5 className="anc-modal-title">Description</h5>
              <button type="button" onClick={() => setShowModal(false)} className="anc-modal-close">×</button>
            </div>

            <div className="anc-modal-body">
              <div className="anc-modal-row">
                <label className="anc-modal-label">Name <span className="anc-required">*</span></label>
                <input type="text" name="name" value={modalData.name} onChange={handleModalChange} className="anc-modal-input" />
              </div>
              <div className="anc-modal-row">
                <label className="anc-modal-label">Amount (£)</label>
                <input type="number" name="amount" value={modalData.amount} onChange={handleModalChange} className="anc-modal-input" />
              </div>
            </div>

            <div className="anc-modal-footer">
              <button type="button" onClick={() => setShowModal(false)} className="anc-btn-danger">Cancel</button>
              <button type="button" onClick={handleAddDescription} className="anc-btn-primary">Save</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ marginTop: '20px' }}>
        <div style={{ width: '95%', margin: '0 auto' }}>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default AddnextCase;